export default __webpack_public_path__ + "static/media/TeamNameTag.c6ea77a6.png";